import React, { useMemo, useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Row,
  Col,
  Input,
  Table,
  Button,
} from "reactstrap";

const PlayerProfileGiftTab = ({
  giftSearch,
  setGiftSearch,
  giftPokemonType,
  setGiftPokemonType,
  filteredGiftPokemon,
  selectedGiftPokemon,
  setSelectedGiftPokemon,
  handleSendPokemonGift,
  giftItemSearch,
  setGiftItemSearch,
  giftItemAmount,
  setGiftItemAmount,
  filteredGiftItems,
  selectedGiftItem,
  setSelectedGiftItem,
  handleSendItemGift,
  coinsToSend,
  setCoinsToSend,
  moneyToSend,
  setMoneyToSend,
  handleSendCurrencyGift,
  openAccordion,
  toggleAccordion,
  getLevel,
  myLoading,
  myPage,
  myTotalPages,
  fetchMyPokemon,
  searchMyPokemon,
}) => {
  const [giftItemsPage, setGiftItemsPage] = useState(1);
  const GIFT_ITEMS_PER_PAGE = 12;

  const eligibleGiftItems = useMemo(() => {
    return (filteredGiftItems || []).filter((item) => item.amount > 0);
  }, [filteredGiftItems]);

  const giftItemsTotalPages = Math.max(
    1,
    Math.ceil(eligibleGiftItems.length / GIFT_ITEMS_PER_PAGE),
  );

  useEffect(() => {
    setGiftItemsPage((p) => Math.min(Math.max(1, p), giftItemsTotalPages));
  }, [giftItemsTotalPages]);

  const pagedGiftItems = useMemo(() => {
    const start = (giftItemsPage - 1) * GIFT_ITEMS_PER_PAGE;
    return eligibleGiftItems.slice(start, start + GIFT_ITEMS_PER_PAGE);
  }, [eligibleGiftItems, giftItemsPage]);

  return (
    <Card>
      <CardBody>
        <Accordion open={openAccordion} toggle={toggleAccordion}>
          {/* Accordion for gifting Pokémon */}
          <AccordionItem>
            <AccordionHeader targetId="1">Gift a Pokémon</AccordionHeader>
            <AccordionBody accordionId="1">
              <Row className="mb-3">
                <Col md="4">
                  <Input
                    type="text"
                    placeholder="Search Pokémon..."
                    value={giftSearch}
                    onChange={(e) => {
                      setGiftSearch(e.target.value);
                      searchMyPokemon(e.target.value);
                    }}
                  />
                </Col>
                <Col md="4">
                  <select
                    className="form-control"
                    value={giftPokemonType}
                    onChange={(e) => setGiftPokemonType(e.target.value)}
                  >
                    <option value="all">All Types</option>
                    <option value="diamond">Diamond</option>
                    <option value="emerald">Emerald</option>
                    <option value="golden">Golden</option>
                    <option value="diamond">Sapphire</option>
                    <option value="shadow">Shadow</option>
                    <option value="ruby">Ruby</option>
                    <option value="shiny">Shiny</option>
                  </select>
                </Col>
                <Col md="4">
                  <Button
                    color="primary"
                    onClick={() => searchMyPokemon(giftSearch)}
                  >
                    Search
                  </Button>
                </Col>
              </Row>
              {myLoading ? (
                <div>
                  <img src="/loading.gif" alt="Loading..." width="32" />
                  <span> Loading Pokémon...</span>
                </div>
              ) : (
                <Table striped responsive className="align-middle">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Pokémon</th>
                      <th>Name</th>
                      <th>Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredGiftPokemon.length > 0 ? (
                      filteredGiftPokemon.map((poke) => (
                        <tr
                          key={poke.id}
                          onClick={() => setSelectedGiftPokemon(poke)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>
                            <input
                              type="radio"
                              checked={selectedGiftPokemon?.id === poke.id}
                              onChange={() => setSelectedGiftPokemon(poke)}
                            />
                          </td>
                          <td>
                            <img
                              src={`/sprites/${poke.name}.png`}
                              alt={poke.name}
                              style={{ width: "80px" }}
                            />
                          </td>
                          <td>{poke.nickname || poke.name}</td>
                          <td>{getLevel(poke.totalexp)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No eligible Pokémon found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
              {/* Pagination Controls */}
              <Row className="mt-3">
                <Col md="6">
                  <Button
                    color="secondary"
                    onClick={() => fetchMyPokemon(myPage - 1)}
                    disabled={myPage <= 1}
                  >
                    Previous
                  </Button>
                </Col>
                <Col md="6" className="text-right">
                  <span>
                    Page {myPage} of {myTotalPages}
                  </span>
                  <Button
                    color="secondary"
                    onClick={() => fetchMyPokemon(myPage + 1)}
                    disabled={myPage >= myTotalPages}
                    className="ml-2"
                  >
                    Next
                  </Button>
                </Col>
              </Row>
              <Button
                color="primary"
                onClick={handleSendPokemonGift}
                disabled={!selectedGiftPokemon}
                className="mt-3"
              >
                Send Pokémon Gift
              </Button>
            </AccordionBody>
          </AccordionItem>
          {/* Accordion for gifting an Item */}
          <AccordionItem>
            <AccordionHeader targetId="2">Gift an Item</AccordionHeader>
            <AccordionBody accordionId="2">
              <Row className="mb-3">
                <Col md="4">
                  <Input
                    type="text"
                    placeholder="Search Items..."
                    value={giftItemSearch}
                    onChange={(e) => setGiftItemSearch(e.target.value)}
                  />
                </Col>
                <Col md="4">
                  <Input
                    type="number"
                    placeholder="Amount"
                    value={giftItemAmount}
                    onChange={(e) => setGiftItemAmount(e.target.value)}
                  />
                </Col>
              </Row>
              <Table striped responsive className="align-middle">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Item</th>
                    <th>Name</th>
                    <th>Available</th>
                  </tr>
                </thead>
                <tbody>
                  {eligibleGiftItems.length > 0 ? (
                    pagedGiftItems.map((item) => (
                        <tr
                          key={item.item}
                          onClick={() => setSelectedGiftItem(item)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>
                            <input
                              type="radio"
                              checked={selectedGiftItem?.item === item.item}
                              onChange={() => setSelectedGiftItem(item)}
                            />
                          </td>
                          <td>
                            <img
                              src={item.item_image}
                              alt={item.item_name}
                              style={{ width: "24px" }}
                            />
                          </td>
                          <td>{item.item_name}</td>
                          <td>{item.amount}</td>
                        </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No eligible items found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <Row className="mt-3">
                <Col md="6">
                  <Button
                    color="secondary"
                    onClick={() => setGiftItemsPage((p) => Math.max(1, p - 1))}
                    disabled={giftItemsPage <= 1}
                  >
                    Previous
                  </Button>
                </Col>
                <Col md="6" className="text-right">
                  <span>
                    Page {giftItemsPage} of {giftItemsTotalPages}
                  </span>
                  <Button
                    color="secondary"
                    onClick={() =>
                      setGiftItemsPage((p) => Math.min(giftItemsTotalPages, p + 1))
                    }
                    disabled={giftItemsPage >= giftItemsTotalPages}
                    className="ml-2"
                  >
                    Next
                  </Button>
                </Col>
              </Row>

              <Button
                color="primary"
                onClick={handleSendItemGift}
                disabled={!selectedGiftItem || !giftItemAmount}
              >
                Send Item Gift
              </Button>
            </AccordionBody>
          </AccordionItem>
          {/* Accordion for gifting Currency */}
          <AccordionItem>
            <AccordionHeader targetId="3">Gift Currency</AccordionHeader>
            <AccordionBody accordionId="3">
              <Row className="mb-3">
                <Col md="4">
                  <Input
                    type="number"
                    placeholder="Coins to send"
                    value={coinsToSend}
                    onChange={(e) => setCoinsToSend(e.target.value)}
                  />
                  <div style={{ marginTop: "5px" }}>
                    <img
                      src="/items/coin.png"
                      alt="coin"
                      style={{ width: "24px", verticalAlign: "middle" }}
                    />{" "}
                    Coins
                  </div>
                </Col>
                <Col md="4">
                  <Input
                    type="number"
                    placeholder="Money to send"
                    value={moneyToSend}
                    onChange={(e) => setMoneyToSend(e.target.value)}
                  />
                  <div style={{ marginTop: "5px" }}>
                    <img
                      src="/items/money.png"
                      alt="money"
                      style={{ width: "24px", verticalAlign: "middle" }}
                    />{" "}
                    Money
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md="4">
                  <Button
                    color="primary"
                    onClick={() => handleSendCurrencyGift("coins")}
                    disabled={!coinsToSend}
                  >
                    Send Coins Gift
                  </Button>
                </Col>
                <Col md="4">
                  <Button
                    color="primary"
                    onClick={() => handleSendCurrencyGift("money")}
                    disabled={!moneyToSend}
                  >
                    Send Money Gift
                  </Button>
                </Col>
              </Row>
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </CardBody>
    </Card>
  );
};

export default PlayerProfileGiftTab;
